<template>
  <footer class="footer-shell">
    <div class="container footer-content">
      <div class="row g-4">
        <div
          v-for="office in offices"
          :key="office.title"
          class="col-xl-3 col-md-6"
        >
          <section class="footer-panel">
            <p class="footer-kicker">{{ office.kicker }}</p>
            <h5 class="footer-title">
              <b>{{ office.title }}</b>
            </h5>
            <p class="footer-copy">{{ office.address }}</p>

            <div class="footer-meta">
              <div
                v-for="contact in office.contacts"
                :key="`${office.title}-${contact.label}`"
                class="footer-meta-item"
              >
                <span class="footer-meta-label">{{ contact.label }}</span>
                <a
                  v-if="contact.href"
                  :href="contact.href"
                  class="footer-link"
                >
                  {{ contact.value }}
                </a>
                <span v-else class="footer-meta-value">{{ contact.value }}</span>
              </div>
            </div>
          </section>
        </div>

        <div class="col-xl-3 col-md-6">
          <section class="footer-panel">
            <p class="footer-kicker">Terhubung</p>
            <h5 class="footer-title">
              <b>MEDIA SOSIAL</b>
            </h5>

            <div class="social-cluster">
              <a
                v-for="item in socialLinks"
                :key="item.label"
                :href="item.href"
                class="social-link"
                target="_blank"
                rel="noopener noreferrer"
                :aria-label="item.label"
              >
                <img :src="item.icon" :alt="item.label" class="social-icon" />
              </a>
            </div>

            <div class="footer-note-list">
              <div
                v-for="policy in policyItems"
                :key="policy"
                class="footer-note-item"
              >
                <span class="footer-note-bullet"></span>
                <span class="footer-note-text">{{ policy }}</span>
              </div>
            </div>
          </section>
        </div>

        <div class="col-xl-3 col-md-6">
          <section class="footer-panel">
            <p class="footer-kicker">Komitmen Mutu</p>
            <h5 class="footer-title">
              <b>SERTIFIKASI SISTEM MANAJEMEN</b>
            </h5>

            <div class="certification-grid">
              <div
                v-for="certification in certifications"
                :key="certification.label"
                class="certification-card"
              >
                <img
                  :src="certification.image"
                  :alt="certification.label"
                  class="certification-logo"
                />
              </div>
            </div>
          </section>
        </div>
      </div>

      <div class="footer-bottom">
        <h6 class="footer-bottom-title">Jejaring Grup PI</h6>
        <div class="footer-network">
          <a
            v-for="link in partnerLinks"
            :key="link.label"
            :href="link.href"
            class="footer-network-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ link.label }}
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import twitterIcon from '../assets/Ikon SosMed/1.png'
import facebookIcon from '../assets/Ikon SosMed/2.png'
import instagramIcon from '../assets/Ikon SosMed/3.png'
import smk3Logo from '../assets/ISO/logo-smk3-png-3.webp'
import iso9001Logo from '../assets/ISO/Logo ISO 9001 Pupuk Indonesia Utilitas.png'
import iso14001Logo from '../assets/ISO/Logo ISO 14001 Pupuk Indonesia Utilitas.png'
import iso37001Logo from '../assets/ISO/Logo ISO 37001 Pupuk Indonesia Utilitas.png'
import iso45001Logo from '../assets/ISO/Logo ISO 45001 Pupuk Indonesia Utilitas.png'

export default {
  name: 'FooterSection',
  data() {
    return {
      offices: [
        {
          kicker: 'Kantor Pusat',
          title: 'PT PUPUK INDONESIA UTILITAS',
          address:
            'Gedung ROB 1 Lt. 5, Jl. Kalibata Timur I No. 36, Jakarta Selatan, 12740',
          contacts: [
            {
              label: 'Phone',
              value: '(021) 29661630',
              href: 'tel:+622129661630'
            },
            {
              label: 'Email',
              value: 'info@pi-utilitas.com',
              href: 'mailto:info@pi-utilitas.com'
            }
          ]
        },
        {
          kicker: 'Operasional',
          title: 'IPP GRESIK (GRESIK GAS COGENERATION PLANT)',
          address:
            'Jalan Gubernur Suryo, Pabrik 3 PT Petrokimia Gresik, Gresik, Jawa Timur',
          contacts: [
            {
              label: 'Phone',
              value: '-'
            },
            {
              label: 'Email',
              value: 'info@pi-utilitas.com',
              href: 'mailto:info@pi-utilitas.com'
            }
          ]
        }
      ],
      socialLinks: [
        {
          label: 'Twitter',
          href: 'https://twitter.com/PIUtilitas',
          icon: twitterIcon
        },
        {
          label: 'Facebook',
          href: 'https://www.facebook.com/Pupuk.Indonesia',
          icon: facebookIcon
        },
        {
          label: 'Instagram',
          href: 'https://www.instagram.com/pi_utilitas/',
          icon: instagramIcon
        }
      ],
      policyItems: [
        'Syarat & Ketentuan Penggunaan Website',
        'Kebijakan Privasi'
      ],
      certifications: [
        {
          label: 'SMK3',
          image: smk3Logo
        },
        {
          label: 'ISO 9001:2015',
          image: iso9001Logo
        },
        {
          label: 'ISO 14001:2015',
          image: iso14001Logo
        },
        {
          label: 'ISO 37001:2016',
          image: iso37001Logo
        },
        {
          label: 'ISO 45001',
          image: iso45001Logo
        }
      ],
      partnerLinks: [
        {
          label: 'KEMENTERIAN BUMN',
          href: 'https://bumn.go.id/'
        },
        {
          label: 'PT PUPUK INDONESIA',
          href: 'https://www.pupuk-indonesia.com/'
        },
        {
          label: 'PT PETROKIMIA GRESIK',
          href: 'https://www.petrokimia-gresik.com/'
        },
        {
          label: 'PT PUPUK KUJANG CIKAMPEK',
          href: 'https://www.pupuk-kujang.co.id/'
        },
        {
          label: 'PT REKAYASA INDUSTRI',
          href: 'http://www.rekayasa.com/'
        },
        {
          label: 'PT PUPUK KALIMANTAN TIMUR',
          href: 'http://www.pupukkaltim.com/'
        },
        {
          label: 'PT PUPUK SRIWIDJAJA PALEMBANG',
          href: 'https://www.pusri.co.id/'
        },
        {
          label: 'PT PUPUK ISKANDAR MUDA',
          href: 'https://www.pim.co.id/'
        },
        {
          label: 'PT KALTIM DAYA MANDIRI',
          href: 'https://kaltimdayamandiri.co.id/'
        }
      ]
    }
  }
}
</script>

<style scoped>
.footer-shell {
  position: relative;
  overflow: hidden;
  padding: 72px 0 36px;
  background:
    radial-gradient(circle at top right, rgba(117, 201, 255, 0.22), transparent 28%),
    linear-gradient(135deg, #0b4d84 0%, #0f629f 48%, #083a61 100%);
  color: rgba(240, 247, 255, 0.9);
}

.footer-shell::before {
  content: '';
  position: absolute;
  inset: 0;
  background-image: url('../assets/LOGO PIU Footer.png');
  background-repeat: no-repeat;
  background-position: -60px bottom;
  background-size: min(420px, 40vw);
  opacity: 0.12;
  pointer-events: none;
}

.footer-shell::after {
  content: '';
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 12% 18%, rgba(255, 255, 255, 0.12), transparent 18%),
    radial-gradient(circle at 82% 12%, rgba(255, 255, 255, 0.08), transparent 16%);
  pointer-events: none;
}

.footer-content {
  position: relative;
  z-index: 1;
}

.footer-panel {
  height: 100%;
  padding: 28px 24px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 24px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.14), rgba(255, 255, 255, 0.06));
  box-shadow: 0 24px 48px rgba(3, 27, 48, 0.22);
  backdrop-filter: blur(10px);
}

.footer-kicker {
  margin-bottom: 10px;
  color: rgba(220, 236, 255, 0.74);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.footer-title {
  margin-bottom: 14px;
  color: #fff;
  font-size: 1.25rem;
  line-height: 1.35;
}

.footer-copy {
  margin-bottom: 18px;
  color: rgba(240, 247, 255, 0.88);
  font-size: 0.98rem;
  line-height: 1.75;
}

.footer-meta {
  display: grid;
  gap: 14px;
}

.footer-meta-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-top: 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.footer-meta-label {
  color: rgba(215, 232, 255, 0.7);
  font-size: 0.76rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.footer-meta-value,
.footer-note-text {
  color: rgba(240, 247, 255, 0.9);
  line-height: 1.65;
}

.footer-link {
  color: #fff;
  line-height: 1.65;
  text-decoration: underline;
  text-decoration-color: rgba(255, 255, 255, 0.5);
  text-underline-offset: 3px;
}

.footer-link:hover {
  color: #fff;
  text-decoration-color: #fff;
}

.social-cluster {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 18px 0 22px;
}

.social-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.14);
  box-shadow: 0 14px 26px rgba(5, 28, 55, 0.18);
  transition:
    transform 0.2s ease,
    background-color 0.2s ease,
    border-color 0.2s ease;
}

.social-link:hover {
  transform: translateY(-2px);
  border-color: rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.22);
}

.social-icon {
  width: 30px;
  height: 30px;
  object-fit: contain;
}

.footer-note-list {
  display: grid;
  gap: 10px;
}

.footer-note-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.08);
}

.footer-note-bullet {
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  margin-top: 9px;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 0 0 5px rgba(255, 255, 255, 0.08);
}

.certification-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  margin-top: 18px;
}

.certification-card {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 96px;
  padding: 14px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.08);
}

.certification-logo {
  max-width: 100%;
  max-height: 64px;
  object-fit: contain;
}

.footer-bottom {
  margin-top: 32px;
  padding-top: 28px;
  border-top: 1px solid rgba(255, 255, 255, 0.18);
}

.footer-bottom-title {
  margin-bottom: 14px;
  color: #fff;
  font-size: 0.86rem;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-align: center;
  text-transform: uppercase;
}

.footer-network {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
}

.footer-network-link {
  padding: 10px 16px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  font-size: 0.92rem;
  line-height: 1.4;
  text-decoration: none;
  transition:
    transform 0.2s ease,
    background-color 0.2s ease,
    border-color 0.2s ease;
}

.footer-network-link:hover {
  transform: translateY(-1px);
  border-color: rgba(255, 255, 255, 0.28);
  background: rgba(255, 255, 255, 0.16);
  color: #fff;
}

@media (max-width: 1199px) {
  .footer-title {
    font-size: 1.15rem;
  }
}

@media (max-width: 991px) {
  .footer-shell {
    padding: 56px 0 30px;
  }

  .footer-shell::before {
    background-position: -80px bottom;
    background-size: min(360px, 60vw);
    opacity: 0.1;
  }
}

@media (max-width: 767px) {
  .footer-panel {
    padding: 22px 18px;
    border-radius: 20px;
  }

  .footer-copy,
  .footer-meta-value,
  .footer-note-text {
    font-size: 0.95rem;
  }

  .social-link {
    width: 54px;
    height: 54px;
    border-radius: 16px;
  }

  .footer-bottom {
    margin-top: 24px;
    padding-top: 22px;
  }
}

@media (max-width: 575px) {
  .certification-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .footer-bottom-title {
    text-align: left;
  }

  .footer-network {
    justify-content: flex-start;
  }
}
</style>
